import { TranslationObject } from 'ontime-types';

export const langFr: TranslationObject = {
  'common.expected_finish': 'Fin estimée à',
  'common.minutes': 'min',
  'common.seconds': 'sec',
  'common.now': 'Maintenant',
  'common.next': 'A suivre',
  'common.scheduled_start': 'Début prévu',
  'common.scheduled_end': 'Fin prévue',
  'common.expected_start': 'Début projeté',
  'common.expected_end': 'Fin projetée',
  'common.timer_message': 'Message du minuteur',
  'common.secondary_message': 'Message secondaire',
  'common.stage_timer': 'Minuteur de scène',
  'common.started_at': 'Commencé à',
  'common.time_now': 'Heure',
  'common.no_data': 'Aucune donnée',
  'countdown.ended': 'Évènement terminé à',
  'countdown.running': 'Évènement en cours',
  'countdown.group_running': 'Évènement du groupe en cours',
  'countdown.loaded': 'Évènement chargé',
  'countdown.select_event': 'Sélectionnez un évènement à suivre',
  'countdown.to_start': 'Évènement commence dans',
  'countdown.waiting': 'En attente du début de l’évènement',
  'countdown.overtime': 'en dépassement',
  'countdown.all_have_finished': 'Tous les évènements sélectionnés ont terminé',
  'timeline.live': 'live',
  'timeline.done': 'Terminé',
  'timeline.due': 'dû',
  'timeline.followedby': 'Suivi de',
  'timeline.standby': 'En attente',
  'project.title': 'Titre',
  'project.description': 'Description',
  'project.info': 'Informations du projet',
  'project.url': 'URL du projet',
};
